{
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "add": "Add",
    "close": "Close",
    "confirm": "Confirm",
    "export": "Export",
    "refresh": "Refresh"
  },
  "fields": {
    "status": "Status",
    "name": "Name",
    "code": "Code",
    "description": "Description",
    "createdDate": "Created"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "table": {
    "search": "Search...",
    "noResults": "No records found.",
    "rowsPerPage": "Rows per page",
    "all": "All",
    "exportCsv": "Export CSV",
    "clearFilters": "Clear filters"
  },
  "confirmDelete": {
    "title": "Delete record?",
    "message": "This action cannot be undone.",
    "confirmLabel": "Delete"
  },
  "errors": {
    "generic": "Something went wrong. Please try again.",
    "network": "Network error — check your connection and try again.",
    "forbidden": "You do not have permission to perform this action.",
    "notFound": "The requested resource was not found."
  },
  "barcodeScan": {
    "label": "Scan Barcode",
    "placeholder": "Scan or type a barcode, then press Enter",
    "notFound": "Barcode not recognized.",
    "lookupFailed": "Could not look up this barcode. Please try again.",
    "selectWarehouseFirst": "Select a warehouse first to enable barcode scanning.",
    "resolvedBatch": "Batch: {{batchNo}}",
    "resolvedMaterialOnly": "Material identified — pick the location and batch manually.",
    "cameraDialogTitle": "Scan Barcode",
    "cameraStarting": "Starting camera…",
    "cameraScanningHint": "Point the camera at a barcode.",
    "cameraPermissionDenied": "Camera access was denied. Please allow camera permission and try again.",
    "cameraNotFound": "No camera was found on this device.",
    "cameraUnavailable": "Could not access the camera. Please try again."
  }
}
